<template>
<div class="col-md-10 mx-auto">
<div class="row">
<div class="col text-right pb-md-0 pb-4">
  <a v-if="auth == 0" href="/register" class="btn btn-success signup">Start free trial</a>
  <a v-else href="/websites" class="btn btn-success signup">Go to websites</a>
</div>
<div class="col text-left pb-md-0 pb-4">
  <a href="/demo" class="btn btn-danger signup">See live demo</a>
</div>
</div>
</div>
</template>

<script>
export default {
  props: ['auth']
}
</script>